import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "flex w-full max-w-[480px] flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm" };
const _hoisted_2 = { class: "flex flex-col items-center gap-6 p-12" };
const _hoisted_3 = {
    key: 0,
    d: "M5 12l5 5l10 -10"
};
const _hoisted_4 = {
    key: 1,
    d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0-18 0M12 8h.01M11 12h1v4h1"
};
const _hoisted_5 = {
    key: 2,
    d: "M18 6l-12 12M6 6l12 12"
};
const _hoisted_6 = {
    key: 3,
    d: "M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
};
const _hoisted_7 = { class: "text-center text-2xl font-bold text-gray-900" };
const _hoisted_8 = { class: "max-w-xs text-center text-sm leading-relaxed text-gray-500" };
const _hoisted_9 = {
    key: 0,
    class: "w-full rounded-xl border border-green-200 bg-green-50 p-4 text-center text-sm text-green-700"
};
const _hoisted_10 = {
    key: 1,
    class: "w-full rounded-xl border border-blue-200 bg-blue-50 p-4 text-center text-sm text-blue-700"
};
const _hoisted_11 = {
    key: 2,
    class: "w-full rounded-xl border border-amber-200 bg-amber-50 p-4 text-center text-sm text-amber-700"
};
const _hoisted_12 = {
    key: 3,
    class: "w-full rounded-xl border border-red-200 bg-red-50 p-4 text-center text-sm text-red-700"
};
const _hoisted_13 = ["href"];
const _hoisted_14 = {
    key: 5,
    href: "/",
    class: "text-sm text-gray-400 hover:text-gray-600"
};
import { computed } from "vue";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ReviewStateDisplay',
    props: {
        state: {},
        supportEmail: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const isSuccess = computed(() => props.state === "success");
        const isInfo = computed(() => props.state === "already_submitted");
        const isError = computed(() => props.state === "invalid");
        const isWarning = computed(() => props.state === "revoked" ||
            props.state === "expired" ||
            props.state === "consumed" ||
            props.state === "disabled");
        const supportHref = computed(() => props.supportEmail ? `mailto:${props.supportEmail}` : null);
        const accentColor = computed(() => {
            if (isSuccess.value)
                return "bg-green-500";
            if (isInfo.value)
                return "bg-blue-500";
            if (isError.value)
                return "bg-red-500";
            if (isWarning.value)
                return "bg-amber-400";
            return "bg-gray-200";
        });
        const iconBgColor = computed(() => {
            if (isSuccess.value)
                return "bg-green-50";
            if (isInfo.value)
                return "bg-blue-50";
            if (isError.value)
                return "bg-red-50";
            if (isWarning.value)
                return "bg-amber-50";
            return "bg-gray-100";
        });
        const iconColor = computed(() => {
            if (isSuccess.value)
                return "text-green-500";
            if (isInfo.value)
                return "text-blue-500";
            if (isError.value)
                return "text-red-500";
            if (isWarning.value)
                return "text-amber-500";
            return "text-gray-400";
        });
        const title = computed(() => {
            switch (props.state) {
                case "success":
                    return t("reviews.success.title");
                case "already_submitted":
                    return t("reviews.submitted.title");
                case "invalid":
                    return t("reviews.invalid.title");
                case "revoked":
                    return t("reviews.revoked.title");
                case "expired":
                    return t("reviews.expired.title");
                case "consumed":
                    return t("reviews.consumed.title");
                case "disabled":
                    return t("reviews.disabled.title");
                default:
                    return "";
            }
        });
        const description = computed(() => {
            switch (props.state) {
                case "success":
                    return t("reviews.success.description");
                case "already_submitted":
                    return t("reviews.submitted.description");
                case "invalid":
                    return t("reviews.invalid.description");
                case "revoked":
                    return t("reviews.revoked.description");
                case "expired":
                    return t("reviews.expired.description");
                case "consumed":
                    return t("reviews.consumed.description");
                case "disabled":
                    return t("reviews.disabled.description");
                default:
                    return "";
            }
        });
        const recovery = computed(() => {
            switch (props.state) {
                case "invalid":
                    return t("reviews.invalid.recovery");
                case "revoked":
                    return t("reviews.revoked.recovery");
                case "expired":
                    return t("reviews.expired.recovery");
                case "consumed":
                    return t("reviews.consumed.recovery");
                case "disabled":
                    return t("reviews.disabled.recovery");
                default:
                    return "";
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["h-1 w-full", accentColor.value])
                }, null, 2),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["flex h-18 w-18 items-center justify-center rounded-full", iconBgColor.value]),
                        "aria-hidden": "true"
                    }, [
                        (_openBlock(), _createElementBlock("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            class: _normalizeClass(["h-9 w-9", iconColor.value]),
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                        }, [
                            (isSuccess.value)
                                ? (_openBlock(), _createElementBlock("path", _hoisted_3))
                                : (isInfo.value)
                                    ? (_openBlock(), _createElementBlock("path", _hoisted_4))
                                    : (isError.value)
                                        ? (_openBlock(), _createElementBlock("path", _hoisted_5))
                                        : (_openBlock(), _createElementBlock("path", _hoisted_6))
                        ], 2))
                    ], 2),
                    _createElementVNode("h1", _hoisted_7, _toDisplayString(title.value), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(description.value), 1),
                    (isSuccess.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("reviews.success.thank_you")), 1))
                        : (isInfo.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("reviews.submitted.thank_you")), 1))
                            : (isWarning.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(recovery.value), 1))
                                : (isError.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(recovery.value), 1))
                                    : _createCommentVNode("", true),
                    ((isError.value || isWarning.value) && supportHref.value)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 4,
                            href: supportHref.value,
                            class: _normalizeClass(["flex w-full items-center justify-center rounded-xl py-2.5 text-sm font-semibold transition-colors", isError.value ? 'bg-red-500 text-white hover:bg-red-600' : 'border border-gray-200 bg-white text-gray-700 hover:bg-gray-50'])
                        }, _toDisplayString(_ctx.$t("reviews.invalid.support_cta")), 11, _hoisted_13))
                        : _createCommentVNode("", true),
                    (isSuccess.value || isInfo.value)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_14, _toDisplayString(_ctx.$t("reviews.accessibility.back_home")), 1))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
